
export { customerStoreAPI } from "/opt/atlassian/pipelines/agent/build/packages/modules/module-customer/src/stores/customer-store.public-api.ts"